import { Product } from '@models';

export const makeBundleSKU = (allProducts: Product[]) => {
  const getAllBundleSKUs = allProducts?.filter((item) => item?.sku?.includes('B'));

  if (getAllBundleSKUs?.length > 0) {
    const bundleSku: number[] = [];

    getAllBundleSKUs.map((item) => {
      if (!bundleSku.includes(parseInt(item.sku.substring(1), 10))) {
        // fetching numbers from SKU and pushing it to array
        bundleSku.push(parseInt(item.sku.substring(1), 10));
      }

      return item;
    });

    //Sorting numbers in ascending order
    bundleSku.sort((a, b) => a - b);
    // getting greatest number from array
    const lastSKUNumber: number = bundleSku[bundleSku.length - 1] + 1;
    // getting number of zero
    const numberOfZero: number = 6 - lastSKUNumber.toString().length;

    const sku: string = 'B'.padEnd(numberOfZero, '0') + lastSKUNumber;

    return sku;
  } else {
    return 'B00001';
  }
};
